import React, { useEffect, useState } from "react";
import { forwardToNewDesign } from "../../utils/forwardToNewDesign";
import { useNavigate } from "react-router-dom";
import { postRequest } from "../../services/api/apiService";
import { getAuthToken } from "../../utils/auth";
import { afterPlatformConnect } from "../../utils/afterPlatformConnect";

// Retour d'autorisation Reddit : Reddit renvoie ?code=…&state=… sur
// /ads/reddit-callback. On échange le code côté serveur (le secret ne
// transite jamais par le navigateur), puis on revient sur Plateformes
// connectées où l'utilisateur choisit son compte publicitaire.
const RedditAdsCallback = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (forwardToNewDesign()) return; // tunnel lancé depuis un autre client OneBotAds
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");
    const denied = queryParams.get("error");
    const token = getAuthToken();

    // Reddit renvoie ?error=access_denied si l'utilisateur refuse — ce n'est
    // pas une panne, on le ramène simplement à l'écran précédent.
    if (denied) {
      setError(
        denied === "access_denied"
          ? "Connexion Reddit annulée."
          : `Reddit a refusé l'autorisation (${denied}).`
      );
      return;
    }

    if (!code) {
      setError("Code d'autorisation manquant.");
      return;
    }

    postRequest(
      "/api/ads-auth/reddit/callback",
      { code },
      { Authorization: `Bearer ${token}` }
    )
      .then((response) => {
        if (response?.success) {
          navigate(afterPlatformConnect());
        } else {
          setError("Échec de l'enregistrement du compte Reddit Ads.");
        }
      })
      .catch(() => {
        setError("Erreur pendant l'authentification Reddit Ads.");
      });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      {error ? (
        <div className="max-w-md text-center">
          <p className="text-red-600 font-medium mb-4">{error}</p>
          <button
            onClick={() => navigate(afterPlatformConnect())}
            className="px-4 py-2 bg-[#221C51] text-white rounded-lg hover:bg-[#2e265e]"
          >
            Retour aux plateformes
          </button>
        </div>
      ) : (
        <p className="text-gray-500">Connexion à Reddit en cours…</p>
      )}
    </div>
  );
};

export default RedditAdsCallback;
